/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_OfflineInputs */

const en_svtag_offline = /** @type {(inputs: Svtag_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#OFFLINE`)
};

const ar_svtag_offline = /** @type {(inputs: Svtag_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#غير_متصل`)
};

const bn_svtag_offline = /** @type {(inputs: Svtag_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#OFFLINE`)
};

const de_svtag_offline = /** @type {(inputs: Svtag_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#OFFLINE`)
};

const es_svtag_offline = /** @type {(inputs: Svtag_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#OFFLINE`)
};

const fr_svtag_offline = /** @type {(inputs: Svtag_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#OFFLINE`)
};

const pt_svtag_offline = /** @type {(inputs: Svtag_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#OFFLINE`)
};

const zh_svtag_offline = /** @type {(inputs: Svtag_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#OFFLINE`)
};

const tr_svtag_offline = /** @type {(inputs: Svtag_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#OFFLINE`)
};

const ru_svtag_offline = /** @type {(inputs: Svtag_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#OFFLINE`)
};

const pl_svtag_offline = /** @type {(inputs: Svtag_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#OFFLINE`)
};

/**
* | output |
* | --- |
* | "#OFFLINE" |
*
* @param {Svtag_OfflineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_offline = /** @type {((inputs?: Svtag_OfflineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_OfflineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_offline(inputs)
	if (locale === "bn") return bn_svtag_offline(inputs)
	if (locale === "de") return de_svtag_offline(inputs)
	if (locale === "es") return es_svtag_offline(inputs)
	if (locale === "fr") return fr_svtag_offline(inputs)
	if (locale === "pt") return pt_svtag_offline(inputs)
	if (locale === "zh") return zh_svtag_offline(inputs)
	if (locale === "tr") return tr_svtag_offline(inputs)
	if (locale === "ru") return ru_svtag_offline(inputs)
	if (locale === "pl") return pl_svtag_offline(inputs)
	return en_svtag_offline(inputs)
});